import animations from './animations';
import buttons from './buttons';
import colors from './colors';
import icons from './icons';
import zIndex from './zIndexRegistry';
import breakpoints from './breakpoints';
import inputs from './inputs';
import pageContent from './pageContent';
import * as designSystem from './designSystem';
import fonts from './fonts';

const theme = {
  animations,
  breakpoints,
  buttons,
  colors,
  designSystem,
  icons,
  inputs,
  pageContent,
  zIndex,
  fonts
};

export default theme;
